import type { StoryblokMultilink } from "@/types/storyblok";

/**
 * Normalize a URL for use in Next.js Link components
 * Handles absolute URLs (http/https), relative paths, and ensures proper formatting
 */
export function normalizeUrl(url: string): string {
  if (!url || url === "#") return "#";

  // If it's already an absolute URL (http:// or https://), use it as-is
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  // If it starts with /, it's already a relative path, use as-is
  if (url.startsWith("/")) {
    return url;
  }

  // Otherwise, prepend / to make it a relative path
  return `/${url}`;
}

/**
 * Get URL from Storyblok multilink field
 * Ensures story links are absolute paths by prepending a forward slash
 * Normalizes external URLs properly
 */
export function getUrlFromMultilink(link?: StoryblokMultilink): string {
  if (!link) return "#";

  // For story links, ensure they start with / to make them absolute
  if (link.linktype === "story" && link.cached_url) {
    return normalizeUrl(link.cached_url);
  }

  // For external/email/asset links, use the url field and normalize it
  return normalizeUrl(link.url || "#");
}
